/*
 * DAW · Inscription aux drops — envoi vers Klaviyo (API client, clé publique).
 *
 * Consentements recueillis séparément pour l'e-mail et le SMS, cases décochées
 * par défaut. Aucun profil n'est créé sans consentement e-mail explicite.
 *
 * REVISION : version de l'API Klaviyo. Klaviyo retire les versions anciennes ;
 * si l'inscription échoue un jour avec une erreur de révision, mettre à jour
 * cette date avec la version courante indiquée dans la documentation Klaviyo.
 *
 * En cas d'échec, le détail renvoyé par Klaviyo est affiché et écrit dans la
 * console du navigateur, pour pouvoir diagnostiquer sans deviner.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var REVISION = '2026-07-15';

  function isEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  }

  /* Numéro au format international attendu par Klaviyo (E.164). */
  function normalizePhone(value) {
    var s = (value || '').replace(/[\s.\-() ]/g, '');
    if (!s) return '';
    if (s.charAt(0) === '+') return s;
    if (s.slice(0, 2) === '00') return '+' + s.slice(2);
    if (s.charAt(0) === '0' && s.length === 10) return '+33' + s.slice(1);
    if (s.slice(0, 2) === '33' && s.length === 11) return '+' + s;
    return '';
  }

  function init(root) {
    var key = root.getAttribute('data-key');
    var list = root.getAttribute('data-list');
    var source = root.getAttribute('data-source') || 'DropAndWatch';
    var successMsg =
      root.getAttribute('data-success') ||
      'C’est noté, vous êtes sur la liste. Un e-mail de bienvenue arrive dans un instant.';
    var form = root.querySelector('[data-daw-signup-form]');
    if (!key || !list || !form) return;

    var emailEl = root.querySelector('[data-daw-email]');
    var phoneEl = root.querySelector('[data-daw-phone]');
    var consentEmailEl = root.querySelector('[data-daw-consent-email]');
    var consentSmsEl = root.querySelector('[data-daw-consent-sms]');
    var submitEl = root.querySelector('[data-daw-signup-submit]');
    var msgEl = root.querySelector('[data-daw-signup-msg]');

    function say(text, kind) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.className = 'daw-signup__msg daw-signup__msg--' + kind;
      msgEl.hidden = false;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var email = (emailEl && emailEl.value ? emailEl.value : '').trim();
      var phoneRaw = phoneEl && phoneEl.value ? phoneEl.value : '';
      var wantsEmail = consentEmailEl ? consentEmailEl.checked : false;
      var wantsSms = consentSmsEl ? consentSmsEl.checked : false;

      if (!isEmail(email)) {
        say('Merci de saisir une adresse e-mail valide.', 'ko');
        return;
      }
      if (!wantsEmail) {
        say('Merci de cocher la case d’accord pour recevoir nos annonces par e-mail.', 'ko');
        return;
      }

      var phone = '';
      if (wantsSms) {
        phone = normalizePhone(phoneRaw);
        if (!phone) {
          say('Pour être prévenu par SMS, indiquez un numéro de téléphone valide.', 'ko');
          return;
        }
      } else if (phoneRaw) {
        phone = normalizePhone(phoneRaw);
      }

      var subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
      if (wantsSms && phone) {
        subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
      }

      var attributes = { email: email, subscriptions: subscriptions };
      if (phone) attributes.phone_number = phone;

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: { data: { type: 'profile', attributes: attributes } }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      };

      if (submitEl) submitEl.disabled = true;
      say('Enregistrement…', 'pending');

      fetch(ENDPOINT + '?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: REVISION },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (response.status === 202 || response.ok) {
            form.reset();
            say(successMsg, 'ok');
            if (submitEl) submitEl.disabled = true;
            return null;
          }
          return response.text().then(function (body) {
            var detail = '';
            try {
              var parsed = JSON.parse(body);
              if (parsed && parsed.errors && parsed.errors.length) {
                detail = parsed.errors[0].detail || parsed.errors[0].title || '';
              }
            } catch (e) {
              detail = body ? body.slice(0, 200) : '';
            }
            /* eslint-disable no-console */
            console.log('[DAW inscription] statut', response.status, body);
            if (submitEl) submitEl.disabled = false;
            say(
              'L’inscription n’a pas pu être enregistrée (erreur ' +
                response.status +
                (detail ? ' — ' + detail : '') +
                ').',
              'ko'
            );
            return null;
          });
        })
        .catch(function (error) {
          console.log('[DAW inscription] échec réseau', error);
          if (submitEl) submitEl.disabled = false;
          say(
            'L’inscription n’a pas pu être envoyée (réseau ou blocage du navigateur). Détail dans la console.',
            'ko'
          );
        });
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-daw-signup]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
